import type { RouteLocationNormalized } from 'vue-router'
import { defineNuxtRouteMiddleware } from '#app'
import { FORBIDDEN_ACCESS_PAGE_PATH } from '~/shared/models/ForbiddenAccess'
import useForbiddenAccessStore from '~/shared/stores/useForbiddenAccessStore'

/**
 * Clears stale forbidden-access context when the user navigates to a normal page.
 * Keeps the context only while entering/staying on the not-allowed page, so a later
 * successful revisit (e.g. after a permission grant) does not merge old slugs.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  if (to.path === FORBIDDEN_ACCESS_PAGE_PATH) {
    return
  }

  const forbiddenAccessStore = useForbiddenAccessStore()
  if (forbiddenAccessStore.blockedFrom == null && forbiddenAccessStore.missingPermissions.length === 0) {
    return
  }

  forbiddenAccessStore.clearForbiddenAccess()
})
